<template>
  <LegalPageShell
    title="Política de privacidade"
    subtitle="Como tratamos dados pessoais na plataforma GetLance e em integrações autorizadas (incluindo Google)."
    :alternate-legal-link="{ to: '/termos-de-servico', label: 'Termos de serviço' }"
  >
    <p class="text-neutrals_text/70 text-xs sm:text-sm">
      Última atualização: 10 de maio de 2026. Este texto é um modelo base para transparência e para cadastro em
      fluxos OAuth (ex.: Google Cloud / Google Ads API). Revise com assessoria jurídica antes de uso em produção.
    </p>

    <section class="space-y-3">
      <h2 class="text-lg font-bold text-primary">1. Quem somos</h2>
      <p>
        A plataforma <strong>GetLance</strong> (doravante &quot;nós&quot;) oferece serviços digitais de intermediação
        entre prestadores de serviços e contratantes. O site e os aplicativos associados operam sob o domínio
        <strong>getlance.com.br</strong> (e ambientes de homologação quando aplicável).
      </p>
    </section>

    <section class="space-y-3">
      <h2 class="text-lg font-bold text-primary">2. Dados que podemos coletar</h2>
      <ul class="list-disc pl-5 space-y-2">
        <li>Dados de cadastro e conta (nome, e-mail, telefone, tipo de perfil, dados profissionais informados).</li>
        <li>Dados de uso da plataforma (logs técnicos, preferências, interações com anúncios e funcionalidades).</li>
        <li>Dados de localização ou endereço quando necessários para serviços presenciais ou conforme você informar.</li>
        <li>Dados de pagamento tratados por provedores certificados; não armazenamos dados completos de cartão em nossos servidores quando o pagamento é processado pelo parceiro.</li>
      </ul>
    </section>

    <section class="space-y-3">
      <h2 class="text-lg font-bold text-primary">3. Integrações Google (login, APIs e anúncios)</h2>
      <p>
        Quando você autoriza integrações com serviços Google (por exemplo, login com Google, uso da
        <strong>Google Ads API</strong> em nome de contas que você administra, ou outras APIs Google habilitadas no
        projeto), poderemos processar identificadores e metadados necessários para essas funcionalidades, sempre
        conforme as permissões que você conceder na tela de consentimento OAuth e as políticas do Google aplicáveis.
      </p>
      <p>
        O uso das informações obtidas via APIs Google seguirá a
        <a
          href="https://developers.google.com/terms/api-services-user-data-policy"
          class="text-primary underline hover:no-underline"
          target="_blank"
          rel="noopener noreferrer"
        >Política de dados do usuário dos serviços de API do Google</a>,
        incluindo os requisitos de uso limitado quando couber.
      </p>
    </section>

    <section class="space-y-3">
      <h2 class="text-lg font-bold text-primary">4. Finalidades</h2>
      <ul class="list-disc pl-5 space-y-2">
        <li>Prestação do serviço, autenticação, suporte e segurança.</li>
        <li>Melhoria da experiência, métricas agregadas e prevenção a fraudes.</li>
        <li>Cumprimento de obrigações legais e resposta a solicitações legítimas de autoridades.</li>
        <li>Comunicações relacionadas ao serviço (incluindo avisos técnicos e, quando permitido, mensagens de marketing com opção de descadastro).</li>
      </ul>
    </section>

    <section class="space-y-3">
      <h2 class="text-lg font-bold text-primary">5. Bases legais (LGPD)</h2>
      <p>
        Tratamos dados pessoais com fundamento nas bases previstas na Lei nº 13.709/2018 (LGPD), conforme o caso:
        execução de contrato, legítimo interesse (com avaliação de expectativa e balanceamento), consentimento quando
        exigido, cumprimento de obrigação legal ou regulatória e exercício regular de direitos.
      </p>
    </section>

    <section class="space-y-3">
      <h2 class="text-lg font-bold text-primary">6. Compartilhamento</h2>
      <p>
        Podemos compartilhar dados com provedores de infraestrutura, pagamento, e-mail, analytics e outros
        subprocessadores estritamente necessários à operação, sob contratos e medidas de segurança compatíveis com a LGPD.
        Não vendemos seus dados pessoais.
      </p>
    </section>

    <section class="space-y-3">
      <h2 class="text-lg font-bold text-primary">7. Retenção e segurança</h2>
      <p>
        Mantemos dados pelo tempo necessário às finalidades descritas, ao cumprimento legal ou à resolução de disputas.
        Adotamos medidas técnicas e organizacionais razoáveis de proteção; nenhum sistema é 100% invulnerável.
      </p>
    </section>

    <section class="space-y-3">
      <h2 class="text-lg font-bold text-primary">8. Seus direitos</h2>
      <p>
        Você pode solicitar confirmação de tratamento, acesso, correção, anonimização, portabilidade, eliminação de
        dados desnecessários ou revogação de consentimento, nos limites da lei. Envie um e-mail para
        <a href="mailto:contato@getlance.com.br" class="text-primary underline hover:no-underline">contato@getlance.com.br</a>.
      </p>
    </section>

    <section class="space-y-3">
      <h2 class="text-lg font-bold text-primary">9. Alterações</h2>
      <p>
        Podemos atualizar esta política para refletir mudanças legais ou no serviço. A data no topo desta página será
        ajustada quando houver revisão relevante.
      </p>
    </section>
  </LegalPageShell>
</template>

<script>
import LegalPageShell from '@/components/LegalPageShell.vue';

export default {
  name: 'PrivacyPolicyPage',
  components: { LegalPageShell },
  mounted () {
    document.title = 'Política de privacidade | GetLance';
  },
};
</script>
